import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar as MuiSnackbar } from '@memoryfactory/mui-components';

import { selector, closeSnackbar } from './index';

function Snackbar(): React.ReactElement {
  const dispatch = useDispatch();

  const { open, message } = useSelector(selector);

  const onClose = useCallback(() => {
    dispatch(closeSnackbar());
  }, [dispatch]);

  return <MuiSnackbar open={open} message={message} onClose={onClose} />;
}

export default Snackbar;
